export const frontendAccessRules = {
    '/admin/users': ['siteadmin'],
    '/admin/dashboard': ['siteadmin', 'admin'],
    '/admin/messages': ['siteadmin', 'admin']
};